import * as React from "react";
import { Button, ButtonGroup } from "react-bootstrap"

import { appContext } from "../App/appContext"

import { SimpleDialogFormComponent } from "./SimpleDialogFormComponent"

export function hideModal() {
    showModal(<div />);
}

export function showModal(popup: any) {
    if (appContext.dialogShower) {
        appContext.dialogShower.showModal(popup);
    }
}

export function showPopup(title: string, body: any, buttons: any) {
    showModal(<SimpleDialogFormComponent title={title} body={body} buttons={buttons} />);
}

export function showErrorPopup(message: String[]) {
    showPopup("Feil",
        <div>
            {message.map(linje => <div>{linje}</div>) }
        </div>,
        <div>
            <Button bsStyle="primary" onClick={() => hideModal() }>OK</Button>
        </div>);
}

export function showDialog(message: string, action: () => void) {
    showPopup("Vennligst bekreft",
        <div>
            {message}
        </div>,
        <div>
            <ButtonGroup>
                <Button onClick={() => hideModal() }>Avbryt</Button>
                <Button bsStyle="primary" onClick={() => { hideModal(); action(); } }>OK</Button>
            </ButtonGroup>
        </div>);
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/popups.tsx